import { Pipe, PipeTransform } from '@angular/core';

/** Gives back objects within the selected property contains multiple searched properties */

@Pipe({
  name: 'multipleSearchProperty',
  standalone: false
})
export class MultipleSearchPropertyPipe implements PipeTransform {

  /** Comparing input values property to searched string */
  public transform(inputList: any[], searchByList: any) {
    if (Object.keys(searchByList).length > 0) {
      return inputList.filter(inputEl => {
        return Object.keys(searchByList).every(key => {
          return (inputEl[key] as string)?.toString().toLocaleLowerCase() == searchByList[key].toString().toLocaleLowerCase();
        });
      });
    }
    else {
      return inputList;
    }
  }
}